// src/pages/admin/ManageBestSellers.jsx
import React, { useState, useEffect } from 'react';
import { db } from '../../services/firebase';
import { collection, addDoc, deleteDoc, doc, getDocs } from 'firebase/firestore';
import { useBooks } from '../../hooks/useBooks';

const ManageBestSellers = () => {
  const { books } = useBooks();
  const [currentBestSellers, setCurrentBestSellers] = useState([]);
  const [selectedBookId, setSelectedBookId] = useState('');

  useEffect(() => {
    fetchCurrent();
  }, []);

  const fetchCurrent = async () => {
    const snapshot = await getDocs(collection(db, 'bestSellers'));
    setCurrentBestSellers(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const addToBestSellers = async () => {
    if (!selectedBookId) return;
    await addDoc(collection(db, 'bestSellers'), {
      bookId: selectedBookId,
      addedAt: new Date()
    });
    setSelectedBookId('');
    fetchCurrent();
  };

  const removeFromBestSellers = async (docId) => {
    await deleteDoc(doc(db, 'bestSellers', docId));
    fetchCurrent();
  };

  const availableBooks = books.filter(b => !currentBestSellers.some(f => f.bookId === b.id));

  return (
    <div style={{ padding: '20px' }}>
      <h2>Manage Best Sellers</h2>

      <div style={{ marginBottom: '30px' }}>
        <select value={selectedBookId} onChange={e => setSelectedBookId(e.target.value)} style={{ padding: '10px', marginRight: '10px' }}>
          <option value="">Select book to add as Best Seller</option>
          {availableBooks.map(book => (
            <option key={book.id} value={book.id}>{book.title} by {book.author}</option>
          ))}
        </select>
        <button onClick={addToBestSellers} className="button">Add</button>
      </div>

      <h3>Current Best Sellers ({currentBestSellers.length})</h3>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {currentBestSellers.map(item => {
          const book = books.find(b => b.id === item.bookId);
          return (
            <li key={item.id} style={{ padding: '10px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between' }}>
              <span>{book ? `${book.title} by ${book.author}` : 'Book not found'}</span>
              <button onClick={() => removeFromBestSellers(item.id)} style={{ color: 'red', background: 'none', border: 'none', cursor: 'pointer' }}>
                Remove
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ManageBestSellers;